/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MagnetAssignmentFilter {
  IsAssignedDirect = 'IsAssignedDirect',
  IsAssignedDirectOrByDescendants = 'IsAssignedDirectOrByDescendants',
  IsAssignedDirectButNotByDescendants = 'IsAssignedDirectButNotByDescendants'
}
